import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import ScheduledAlertForm from "./ScheduledAlertForm";
import { createScheduledAlert } from "../../collections/scheduledAlerts";

const CreateScheduledAlert = (props) => {
  const navigate = useNavigate();

  useEffect(() => {
    props.setPageTitle("Tạo nhắc nhở");
  }, [props]);

  const handleCreateAlert = async (formData) => {
    try {
      await createScheduledAlert(formData);
      toast.success("Tạo nhắc nhở thành công!", {
        position: "top-center",
        autoClose: 2000,
      });
      navigate("/scheduled-alerts");
    } catch (error) {
      let errorMessage = "Đã xảy ra lỗi không xác định!";
      if (error.response?.data?.error) {
        const errorObj = error.response.data.error;
        if (typeof errorObj === "object") {
          errorMessage = Object.values(errorObj).flat().join("; ");
        } else {
          errorMessage = errorObj;
        }
      }
      toast.error(errorMessage, {
        position: "top-center",
        autoClose: 3000,
      });
    }
  };

  return <ScheduledAlertForm onSubmit={handleCreateAlert} />;
};

export default CreateScheduledAlert;
